export var decodeURIComponentSafe = function (s) {
    try {
        return decodeURIComponent(s);
    }
    catch (error) {
        return s;
    }
};
